/**
 * Document-related models
 */

/**
 * Document DTO (Response)
 */
export interface DocumentDto {
  id: string;
  category?: string | null;
  customerId?: string | null;
  leaseId?: string | null;
  fileUrl: string;
  uploadedBy?: string | null;
  verified: boolean;
  uploadDate: string;
}

